import React from 'react';
import {Route, Switch} from 'react-router-dom';
import RouterSuspense from '~/app/common/RouterSuspense';
import Add from './Add';
import Detail from './Detail';
import TaskDetail from './Detail/Tasks/Detail';
import WorkOrder from './index';

export const WORKORDER_ROUTES = {
    list: '/workorders',
    add: '/workorders/add/:machineId?',
    taskDetail: '/workorders/:id/:type/:taskId',
    detail: '/workorders/:id',
};

export type RouterComponent = React.FC

const Router: RouterComponent = () => (
    <RouterSuspense>
        <Switch>
            {/* <Route path={WORKORDER_ROUTES.add} component={Add} /> */}
            <Route path={WORKORDER_ROUTES.taskDetail} component={TaskDetail} />
            <Route path={WORKORDER_ROUTES.detail} component={Detail} />
            <Route exact path={WORKORDER_ROUTES.list} component={WorkOrder} />
        </Switch>
    </RouterSuspense>
);

export default Router;